import { APIClient } from '@frontend/api-utils';
import { TransactionTriggerTemplate } from '@frontend/transaction/types';

export class TransactionTemplateClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTransactionStateTriggerTemplate(): Promise<TransactionTriggerTemplate> {
        const response = await this.fetch(`${this.endpoint}/transaction-state-triggers`);
        return await this.handleResponse(response);
    }
}
